<template>
    <rkm-overlay>
        <rkm-layout-body title="C3 - Cuidado na gestação e puerpério">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/relatorio-cuidado-gestacao-puerperio/List'

export default {
    components: { List },
}
</script>